import BaseModel from '../core/BaseModel'
import OrganizationModel from './OrganizationModel'
export default class RequestActivationModel extends BaseModel {
    constructor() {
        super({ 
                name: "request_activation",
                tableName: 'core_request_activation'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Thời gian yêu cầu',
                class: 'top-datepicker',
                sortable: true,
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Khách hàng',
                sortable: true,
                width: 15,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    data.full_name = (data.customer_name != undefined && data.customer_name != '') ? data.customer_name : (data.customer_profile !== undefined && data.customer_profile !== null) ? data.customer_profile.full_name  :  '';
                }
            },
            phone_number: { 
                name: 'phone_number', 
                type: "String", 
                label: 'Số điện thoại',
                sortable: true,
                width: 10,
                filter: { type: 'input',  match: 'contains'},
                computed: (data) => {
                    var phoneConvert = (data.customer_profile !== undefined && data.customer_profile !== null) ? data.customer_profile.phone_number  :  '';
                    data.phone_number = phoneConvert.replace('+84', '0');
                }
            },
            organization_id: { 
                name: 'organization_id', 
                label: 'Đơn vị kích hoạt',
                class: 'center',
                type: "Selection",
                sortable: true,
                dataType: 'Label', 
                width: 15,
                params: {select: 'id, name', variables: {status: {'_in': [0, 1]}}},
                models: new OrganizationModel(),
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'}
            },
            processStatus: {
                name: 'processStatus', label: 'Trạng thái xử lý', type: "Selection",  dataType: 'Label',  class: 'center', width: 15,
                options: [{ value: 1, label: 'Đã xử lý'}, { value: 0, label: 'Chờ xử lý'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: true,
                computed: (data) => {
                    var total = (data.request_activation_product_serial_aggregate !== undefined && data.request_activation_product_serial_aggregate !== null) ? data.request_activation_product_serial_aggregate.aggregate.count  :  0;
                    var count = (data.request_activation_product_serial_verify_aggregate !== undefined && data.request_activation_product_serial_verify_aggregate !== null) ? data.request_activation_product_serial_verify_aggregate.aggregate.count  :  0;
                    data.processStatus = (total == count && total > 0) ? 1 : 0;//(data.status == 0 && data.process_status == 0 ) ? 0 : ((data.status == 0 && data.process_status == 1) || data.status == 1) ? 1 : -1;
                }
            },
            products: { 
                name: 'products', 
                label: 'Sản phẩm đã xử lý',
                class: 'center',
                width: 12,
                sortable: true,
                computed: (data) => {
                    var total = (data.request_activation_product_serial_aggregate !== undefined && data.request_activation_product_serial_aggregate !== null) ? data.request_activation_product_serial_aggregate.aggregate.count  :  0;
                    var count = (data.request_activation_product_serial_verify_aggregate !== undefined && data.request_activation_product_serial_verify_aggregate !== null) ? data.request_activation_product_serial_verify_aggregate.aggregate.count  :  0;
                    data.products = count + '/' + total;
                }
            },
            customer_profile_id: {
                refs: 'status process_status customer_name customer_type customer_profile { full_name phone_number} request_activation_product_serial_aggregate(where: {status: {_eq: 1}}) { aggregate { count } } request_activation_product_serial_verify_aggregate(where: {verify_status: {_neq: 0}, status: {_eq: 1}}) { aggregate { count } }',
                display: false
            }
        },)
    }

}